require('./../config.js');

angular.module('deleteUserApiModule', [
  'authorizationMod',
  'config'
])

.service('deleteUserAccount', ['deleteUserApi', function(deleteUserApi) {
  this.deleteUser = function(userName) {
    return deleteUserApi.deleteUser(userName);
  };
}])

.factory('deleteUserApi', ['authService', '$http', 'cnfg', '$httpParamSerializerJQLike', function(authService, $http, cnfg, $httpParamSerializerJQLike) {
  var deleteUserApiObject = {};

  deleteUserApiObject.deleteUser = function(userName) {
    return authService.getToken().then(function(accessToken) {
      var requestConfig = {
        method: 'POST',
        url: cnfg.server_url + '/auth/deleteUser',
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        data: $httpParamSerializerJQLike({
          keyWord: 'rename', // legacy backend quirk for this endpoint - required as-is
          token: accessToken,
          userName: userName
        })
      };
      return $http(requestConfig);
    });
  };

  return deleteUserApiObject;
}]);
